'use strict';

export function Accordion() {
  $('.js-accordion').on('click', function() {
    $(this).toggleClass('is-active').next().stop().slideToggle(300);
    return false;
  });
}